<div class="image-viewer">
  <div class="image-container">
    <div *ngIf="!loadingImage" class="image-display-host">
      <img class="image-display"
           [src]="imageData"
           apZoomable [resetSrc]="imageData"
           (swipe)="onSwipeImg($event)"/>
      <div *ngIf="!disableFullscreen" class="fullscreen-overlay">
        <i class="pull-right fa fa-arrows-alt" (click)="isFullscreenMode = true"></i>
      </div>
    </div>
    <div *ngIf="loadingImage" class="flex-col center-h">
      <ap-spinner size="3"></ap-spinner>
    </div>
  </div>
  <div class="text-center image-footer" *ngIf="pageCount && (pageCount > 1)">
    <nav>
      <mat-paginator [length]="pageCount"
                     [pageIndex]="currentPage - 1"
                     (page)="currentPage = $event.pageIndex + 1; pageChanged()"
                     apIgnorePageSize
                     showFirstLastButtons
                     aria-label="Select page">
      </mat-paginator>
    </nav>
  </div>
  <div *ngIf="isFullscreenMode" class="fullscreen-image-viewer">
    <div class="fullscreen-overlay">
      <i class="pull-right fa fa-times" (click)="isFullscreenMode = false"></i>
    </div>
    <img class="fullscreen-image-display"
         *ngIf="!loadingImage"
         [src]="imageData"
         apZoomable [resetSrc]="imageData"
         (swipe)="onSwipeImg($event)"/>
  </div>
</div>
